import polyfillStructuredClone from "@ungap/structured-clone";

export const clone = polyfillStructuredClone;
